export default __webpack_public_path__ + "static/theworldshardestcheese-ac8160f7410a5f4cb36ff2fed6817c6d.jpg";